import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { updateItemInstanceConfiguration } from 'src/api/updateItemInstanceConfiguration/updateItemInstanceConfiguration';
import { IUpdateItemInstanceConfigurationRequest } from 'src/api/updateItemInstanceConfiguration/types';
import { QueryKeys } from '../QueryKeys';

export const useUpdateItemInstanceConfiguration = (
  itemId: string,
  extensionInstanceId: string,
  onMutationSuccess?: () => void,
) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    (payload: IUpdateItemInstanceConfigurationRequest) =>
      updateItemInstanceConfiguration(itemId, extensionInstanceId, payload),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries({ queryKey: [QueryKeys.item, itemId] });
        showSnackbar({
          message: 'You have successfully updated the item instance configuration',
          status: SnackbarStatus.SUCCESS,
        });
        onMutationSuccess?.();
      },
    },
  );
};
